import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import config, { Environment } from './config';
// Importing for the module-level amplitude.init() side effect.
import './utils/analytics';

Sentry.init({
  dsn: config.sentryDsn,
  ignoreErrors: ['ResizeObserver', 'FirebaseError', 'removeChild', 'insertBefore', 'ConnectError'],
  release: config.sentryRelease,
  environment: Environment[config.environment],
  maxBreadcrumbs: 50,
  enabled: config.environment !== Environment.local,
  integrations: [
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],
});

function AppErrorFallback({
  error,
}: {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}): React.ReactElement {
  const showDetails = config.environment === Environment.local && error instanceof Error;
  return (
    <div style={{ padding: 24, maxWidth: 960, margin: '0 auto' }}>
      <p>An unexpected error occurred. Our team has been notified.</p>
      {showDetails && (
        <pre style={{ whiteSpace: 'pre-wrap', color: '#b00020', marginTop: 16, fontSize: 13 }}>
          {error.message}
          {'\n\n'}
          {error.stack}
        </pre>
      )}
    </div>
  );
}

const AppWithErrorBoundary = Sentry.withErrorBoundary(App, {
  showDialog: true,
  dialogOptions: { title: 'It looks like Experimentation Engine is having issues.' },
  fallback: AppErrorFallback,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWithErrorBoundary />
  </React.StrictMode>,
);
